module.exports = __webpack_public_path__ + "img/invoice.649a40a2.svg";